import Image from '@components/Image';
import { ImageType, type STImageMarker, type STImageMarkerScene } from '@types';
import cn from '@utils/cn';
import type { CSSProperties } from 'react';

interface Props {
  marker: STImageMarker;
  className?: string;
}

const iconStyle = (icon: STImageMarkerScene['icon']): CSSProperties => ({
  width: 16,
  height: 16,
  border: `2px solid rgba(${icon.borderColor})`,
  backgroundColor: `rgba(${icon.fillColor})`,
});

export function ImageMarkerIcon({ marker, className }: Props) {
  if (marker.icon.type === 1) {
    return (
      <Image
        className={cn('w-16 h-16 shrink-0', className)}
        type={
          marker.icon.mediaIcon?.type === 0
            ? ImageType.sysMedia
            : ImageType.media
        }
        src={marker.icon.mediaIcon?.url || ''}
        size={16}
      />
    );
  }
  return (
    <div
      className={cn('shrink-0 rounded-full', className)}
      style={iconStyle(marker.icon)}
    />
  );
}
